export default __webpack_public_path__ + "static/hero-degreehub-3cc9824ef4ad0b3fb051da012600c7a6.png";